import { useFilterData } from 'app/common/ui-components/filter'
import { isDetailsNotAvailable } from '../ReportGenerate/isDetailsNotAvailable'

export const useFiltersSpecialFlags = () => {
  const [, , , { getApplied }] = useFilterData()
  const applied = getApplied()
  if (!applied)
    return {
      excludeOVZ: false,
      datailsNotAvailable: false,
    }
  const { excludeOVZ } = applied
  const datailsNotAvailable = isDetailsNotAvailable(applied)

  return {
    excludeOVZ: excludeOVZ instanceof Array ? excludeOVZ.includes('excludeOVZ') : false,
    datailsNotAvailable,
  }
}
